import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import {
  AccountCustomizedTextsToContinueInstructions,
  AuthenticationContext,
  FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS,
  LinkAccountState
} from '@platform-frontend/account';
import { PollingConfiguration, extendPollingConfiguration } from '@platform-frontend/platform';
import { ClickCallbackLink, TranslationId, TypedChanges } from '@platform-frontend/util';
import { EMPTY, Observable } from 'rxjs';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@Component({
  selector: 'yat-verify-email-ui',
  templateUrl: './verify-email-ui.component.html',
  styleUrls: ['./verify-email-ui.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class VerifyEmailUiComponent implements OnChanges {
  constructor(private store: Store) {}

  @Input()
  scenario: AuthenticationContext | 'secondaryEmail' | 'academic';

  @Input()
  pollingConfiguration: PollingConfiguration;

  @Input()
  email: string | null;

  @Input()
  toContinueInstructions?: AccountCustomizedTextsToContinueInstructions;

  @Output()
  resendEmail: EventEmitter<void> = new EventEmitter();

  @Output()
  cancel: EventEmitter<void> = new EventEmitter();

  accountIdLinked$: Observable<boolean> = this.store.select(LinkAccountState.accountIdLinked);

  readonly resendEmailLink: ClickCallbackLink = {
    onClick: () => this.resendVerification(),
    class: 'link link-secondary link-underline',
    id: '87c95610-6df8-4073-803c-62b974df6c3d'
  };
  readonly changeYourEmailAddressLink: ClickCallbackLink = {
    onClick: () => this.cancelVerification(),
    class: 'link link-secondary link-underline',
    id: 'fd54a161-0b8c-4e41-b394-8dc512ec4fba'
  };

  extendedConfiguration: PollingConfiguration;
  proceeding = false;
  toContinueInstructionsTranslationId: TranslationId = FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS('withContinue').verifyEmail.toContinueInstructions.default;

  ngOnChanges(changes: TypedChanges<VerifyEmailUiComponent>): void {
    if (changes.pollingConfiguration) {
      this.extendedConfiguration = extendPollingConfiguration(this.pollingConfiguration).withComplete(() => this.setToProceeding());
    }
    if (changes.scenario || changes.toContinueInstructions) {
      const withContinue: boolean = this.scenario === 'academic' || this.scenario === 'secondaryEmail';
      const fallbackToContinueInstructions = FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS(withContinue ? 'withContinue' : 'pureSignIn').verifyEmail.toContinueInstructions;
      const usedToContinueInstructions = this.toContinueInstructions ?? fallbackToContinueInstructions;
      this.toContinueInstructionsTranslationId = this.scenario === 'SIGN_IN' ? usedToContinueInstructions.signIn : usedToContinueInstructions.default;
    }
  }

  private setToProceeding(): Observable<unknown> {
    this.proceeding = true;
    return EMPTY;
  }

  private resendVerification(): void {
    this.resendEmail.next();
  }

  private cancelVerification(): void {
    this.cancel.next();
  }
}
